import React from "react";

import { EmptyState, Skeleton, Stack } from "shared/ui";

import { MenuCard } from "features/MenusList/components/MenuCard";
import { TariffExpiredDialog } from "features/MenusList/components/TariffExpiredDialog";
import { useMenusListState } from "features/MenusList/hooks/useMenusListState";

import { Grid, Message } from "./styles";

const MenusListScreen = () => {
    const state = useMenusListState();

    if (state.loading) {
        return (
            <Stack>
                <Skeleton height="280px" />
                <Skeleton height="280px" />
            </Stack>
        );
    }

    if (state.error) {
        return <Message>Не удалось загрузить список меню</Message>;
    }

    return (
        <>
            {state.menus.length === 0 ? (
                <EmptyState
                    title="Меню пока нет"
                    description="Меню — это витрина заведения: гости открывают её по QR-коду и делают заказ."
                />
            ) : (
                <Grid>
                    {state.menus.map((menu) => (
                        <MenuCard key={menu.id} menu={menu} locale={state.locale} />
                    ))}
                </Grid>
            )}

            <TariffExpiredDialog />
        </>
    );
};

export const MenusList = MenusListScreen;
